





















































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import CreateFeeRequest from '@/models/Accounts/Shared/Fees/CreateFeeRequest';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'FeeFromTemplateForm' })
export default class extends SaascadaVueDialog {

    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;

    @Prop({required: true})
    request: CreateFeeRequest;

    @Prop({required: true})
    currency: string;

    get templateSelectValue() {
        if (PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.AdHocFees)) {
            return "subTransactionType";
        }
        else {
            return "value";
        }
    }

    get feeTypes() {
        if (PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.AdHocFees)) {
            return DepositAccountSettingsModule.productIssue.generalFeeSettings.manualFees;
        }
        else {
            return AuthModule.me.institution.config.feeTypes;
        }
    }

}
